// Application Constants – use env vars; no hardcoded localhost or production URLs in code.

const SITE_URL = (process.env.REACT_APP_SITE_URL || '').replace(/\/$/, '') || 'https://radiostreamin.com';

export const APP_CONFIG = {
  NAME: process.env.REACT_APP_SITE_NAME || 'RadioStreamIn.com',
  SITE_URL,
  VERSION: '1.0.0',
  DESCRIPTION: 'A vintage-style internet radio player',
};

/** Base URL for backend API. Use relative /api in dev (with proxy) and production. */
export const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export const API_ENDPOINTS = {
  BASE_URL: API_BASE_URL,
  COUNTRIES: '/countries/',
  STATIONS: '/stations/',
  ANALYTICS: '/analytics/',
  SYNC: '/sync/',
  ADMIN: '/admin/',
};

/** External services – override via env for testing or different providers. */
export const EXTERNAL_URLS = {
  COUNTRY_BY_IP: process.env.REACT_APP_COUNTRY_API_URL || 'https://api.country.is',
  GOOGLE_FAVICON: 'https://www.google.com/s2/favicons',
};

export const AUDIO_CONFIG = {
  DEFAULT_VOLUME: 0.5,
  MAX_VOLUME: 1.0,
  MIN_VOLUME: 0.0
};
